import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SITE } from "@/lib/site";

function CatalogueRow({ c, i }) {
  return (
    <motion.a
      href={`https://wa.me/${SITE.phoneRaw}?text=Hi%20Giriraj!%20I%27m%20interested%20in%20${encodeURIComponent(
        c.title
      )}.`}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => {
        e.preventDefault();
        const url = `https://wa.me/${SITE.phoneRaw}?text=Hi%20Giriraj!%20I%27m%20interested%20in%20${encodeURIComponent(
          c.title
        )}.`;
        const w = window.open(url, "_blank", "noopener,noreferrer");
        if (!w) window.location.href = url;
      }}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-10%" }}
      transition={{ duration: 0.6, delay: i * 0.02, ease: [0.22, 1, 0.36, 1] }}
      data-testid={`catalogue-item-${c.id}`}
      className="group relative border-t border-white/[0.07] hover:border-[#22d3ee]/60 transition-[border-color] duration-500 grid grid-cols-[64px_1fr_auto] items-center gap-4 py-4 md:py-5 px-3 md:px-4 -mx-3 md:-mx-4 rounded-lg hover:bg-white/[0.02]"
    >
      <div className="h-14 w-14 rounded-xl overflow-hidden relative bg-white/[0.05] border border-white/[0.06]">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_35%,rgba(34,211,238,0.22),transparent_60%)]" />
        <img
          src={c.img}
          alt={c.title}
          loading="lazy"
          className="relative z-10 h-full w-full object-contain p-1.5 group-hover:scale-110 transition-transform duration-500"
        />
      </div>
      <div>
        <div className="font-display text-xl md:text-2xl tracking-tight text-white group-hover:text-[#22d3ee] transition-colors duration-500">
          {c.title}
        </div>
        <div className="text-white/50 text-xs md:text-sm mt-1">{c.sub}</div>
      </div>
      <div className="flex items-center gap-3">
        <span className="hidden md:inline font-mono-tag text-[10px] uppercase text-white/40">
          {c.tag}
        </span>
        <span className="h-9 w-9 grid place-items-center rounded-full border border-white/10 group-hover:border-[#22d3ee] group-hover:bg-[#22d3ee] group-hover:text-[#0d1117] transition-colors duration-500">
          <ArrowUpRight className="h-4 w-4" />
        </span>
      </div>
    </motion.a>
  );
}

export default function ProductBentoGrid() {
  return (
    <section
      id="products"
      data-testid="product-grid-section"
      className="relative py-24 md:py-40"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid md:grid-cols-12 gap-10 items-end mb-14 md:mb-20">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="md:col-span-12 font-display text-4xl md:text-6xl lg:text-7xl tracking-tighter leading-[0.98]"
          >
            Every SKU we shelf.{" "}
            <span className="italic font-light text-white/60">
              Tap a line to ping Kunal on WhatsApp.
            </span>
          </motion.h2>
        </div>

        <div className="glass rounded-[28px] p-4 md:p-6">
          <div className="grid md:grid-cols-2 gap-x-6">
            {SITE.categories.map((c, i) => (
              <CatalogueRow c={c} i={i} key={c.id} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
